module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_8011.f49473a8.png";